import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const WorkflowAutomationsTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader
        tabName={t('pageIntegrations.tabNames.workflow-automations')}
      />
      <IntegrationsTable category={IntegrationCategory.WORKFLOW_AUTOMATIONS} />
    </section>
  );
};

export default WorkflowAutomationsTab;
